module.exports = __webpack_public_path__ + "img/why-go-php.ff776ba9.webp";